import { defineMessages } from 'react-intl';

const circularProgressWithLabelScope = 'axionoee.controls.circularProgressWithLabel';
const weekpickerScope = 'axionoee.controls.weekpicker';

export default defineMessages({
  oee: {
    id: `${circularProgressWithLabelScope}.label.oee`,
    defaultMessage: 'OEE',
  },
  a: {
    id: `${circularProgressWithLabelScope}.label.a`,
    defaultMessage: 'A',
  },
  p: {
    id: `${circularProgressWithLabelScope}.label.p`,
    defaultMessage: 'P',
  },
  q: {
    id: `${circularProgressWithLabelScope}.label.q`,
    defaultMessage: 'Q',
  },
  week: {
    id: `${weekpickerScope}.week`,
    defaultMessage: 'Week',
  },
  thisWeek: {
    id: `${weekpickerScope}.thisWeek`,
    defaultMessage: 'This Week',
  },
});